<template>
  <div class="tab-item-cls">
    <div class="title">
      <!-- <span class="tab-img compang-tag"></span>
      <span class="item-title">Company</span> -->
      <p
        class="pde"
        :title="detail"
      >{{detail}}</p>
      <!-- <p v-html="test"></p> -->
    </div>
    <el-row>
      <el-col :span="12">
        <p class="company-title">{{titleList[0]}}</p>
        <barLine :xData="xData1" :serData="serData1" :chartHeight="chartHeight"></barLine>
      </el-col>
      <el-col :span="12">
        <p class="company-title">{{titleList[1]}}</p>
        <barLine :xData="xData2" :serData="serData2" :chartHeight="chartHeight"></barLine>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import barLine from "./barLine";
import color from "./color";
import { getHomeCompany } from "common/js/http/v2Api";
export default {
  props: {
    chartHeight: {
      type: Number
    }
  },

  components: {
    barLine
  },

  data() {
    return {
      xData1: [],
      serData1: [],
      //
      xData2: [],
      serData2: [],
      sData: [
        {
          name: "total1",
          data: [10, 20, 30, 40, 50, 10]
        },
        {
          name: "total2",
          data: [50, 20, 30, 20, 60, 10]
        }
      ],
      titleList: [],
      detail: `It offers detailed information of companies in Asia Pacific, especially the listed companies in China. In this section, you can have an overview of a company and find information including basic profile, transaction information, executive information, share capital structure, shareholders, main financial indicators, financial statements, performance forecast, etc. `,
      // test:`<a>测试</a> <br><span></span>详情</span`
    };
  },

  created() {
    console.log("company create");
  },

  mounted() {
    // this.getData();
    this.getCompanyData();
  },

  methods: {
    getData() {
      this.serData = this.sData.map((item, index) => {
        const itemData = {
          name: item.name,
          type: "bar",
          // stack: "dta",
          data: item.data,
          unit: "%",
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        return itemData;
      });
    },

    async getCompanyData() {
      this.titleList = [];
      this.xData1 = [];
      this.serData1 = [];
      this.xData2 = [];
      this.serData2 = [];

      const { result } = await getHomeCompany();
      this.titleList = Object.keys(result);

      if (this.titleList.length) {
        if (this.titleList[0]) {
          let converResult = {};
          if (result[this.titleList[0]].dataSource == "bvd") {
            converResult = this.convertDataBvd(
              result[this.titleList[0]].totalInfo
            );
          } else {
            converResult = this.convertDataF10(
              result[this.titleList[0]].totalInfo
            );
          }
          this.xData1 = converResult.xData;
          this.serData1 = converResult.serData;
        }

        if (this.titleList[1]) {
          let converResult = {};
          if (result[this.titleList[1]].dataSource == "bvd") {
            converResult = this.convertDataBvd(
              result[this.titleList[1]].totalInfo
            );
          } else {
            converResult = this.convertDataF10(
              result[this.titleList[1]].totalInfo
            );
          }
          this.xData2 = converResult.xData;
          this.serData2 = converResult.serData;
        }
      }
    },

    convertDataF10(data) {
      const xData = [];
      const unit = data[0].exchange_rate_cny_usd;
      const Operating = Object.assign(this.getCommonConfig(0), {
        name: "Operating Income",
        data: [],
        unit
      });
      const totalProfit = Object.assign(this.getCommonConfig(1), {
        name: "Total Profit",
        data: [],
        unit
      });
      const totalAssets = Object.assign(this.getCommonConfig(3), {
        name: "Total Assets",
        data: [],
        unit
      });
      const currentAssets = Object.assign(this.getCommonConfig(4), {
        name: "Current Assets",
        data: [],
        unit
      });

      data.reverse().forEach(item => {
        Operating.data.push(this.setValueByNull(item.operating_income));
        totalProfit.data.push(this.setValueByNull(item.total_profit));
        totalAssets.data.push(this.setValueByNull(item.total_assets));
        currentAssets.data.push(this.setValueByNull(item.current_assets));
        xData.push(item.year);
      });

      return {
        xData,
        serData: [Operating, totalProfit, totalAssets, currentAssets]
      };
    },

    convertDataBvd(data) {
      const xData = [];
      const unit = data[0].original_currency;
      const Operating = Object.assign(this.getCommonConfig(0), {
        name: "Operating Revenue Turnover",
        data: [],
        unit
      });
      const cashFlow = Object.assign(this.getCommonConfig(1), {
        name: "Cash Flow",
        data: [],
        unit
      });
      const totalAssets = Object.assign(this.getCommonConfig(3), {
        name: "Total Assets",
        data: [],
        unit
      });
      const pl = Object.assign(this.getCommonConfig(4), {
        name: "Pl Before Tax",
        data: [],
        unit
      });

      data.reverse().forEach(item => {
        Operating.data.push(
          this.setValueByNull(item.operating_revenue_turnover)
        );
        cashFlow.data.push(this.setValueByNull(item.cash_flow));
        totalAssets.data.push(this.setValueByNull(item.total_assets));
        pl.data.push(this.setValueByNull(item.p_l_before_tax));
        xData.push(item.year);
      });
      return {
        xData,
        serData: [Operating, cashFlow, totalAssets, pl]
      };
    },

    getCommonConfig(index) {
      return {
        name: "",
        type: "bar",
        // stack: "dta",
        data: [],
        unit: "",
        barMinHeight: 5,
        smooth: true,
        itemStyle: {
          normal: {
            color: color[index % 10], //改变折线点的颜色
            lineStyle: {
              color: color[index % 10] //改变折线颜色
            }
          }
        }
      };
    },

    setValueByNull(value) {
      if (!value || value == "null") return 0;
      else return value;
    }
  }
};
</script>

<style scoped>
.company-title {
  font-size: 12px;
  color: #000000;
  margin-top: 30px;
  font-weight: 600;
}
</style>
